<template>
  <v-container fluid ma-0 pa-0 fill-height class="justify-center">
    <v-container v-if="progress" class="justify-center flex-column">
      <v-progress-linear
        indeterminate
        color="yellow darken-2"
      ></v-progress-linear>
      <br />
      <v-progress-linear indeterminate color="orange"></v-progress-linear>
      <br />
    </v-container>
    <v-data-table
      fixed-header
      :height="height - 100"
      :headers="headers"
      :items="userdata"
      item-key="user_id"
      :loading="myloadingvariable"
      loading-text="Loading... Bitte warten"
      @current-items="datenSum"
      loader-height="0"
    >
      <template v-slot:top>
        <!-- v-container, v-col and v-row are just for decoration purposes. -->
        <v-container fluid>
          <v-row>
            <v-col cols="3">
              <v-row class="pa-3">
                <v-text-field
                  v-model="nameFilterValue"
                  type="text"
                  label="Name"
                  append-icon="mdi-magnify"
                ></v-text-field>
              </v-row>
            </v-col>
            <v-col cols="3">
              <v-row class="pa-3">
                <v-select
                  :items="department"
                  v-model="departmentFilterValue"
                  label="Abteilung"
                ></v-select>
              </v-row>
            </v-col>
            <v-col cols="3">
              <v-row class="pa-3">
                <v-select
                  :items="skills"
                  v-model="skillFilterValue"
                  label="Skills"
                ></v-select>
              </v-row>
            </v-col>
            <v-col cols="3">
              <v-row class="pa-3">
                <v-select
                  :items="years"
                  v-model="year"
                  label="year"
                  v-on:change="changeyear"
                ></v-select>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
        <v-dialog v-model="dialog" max-width="910" max-height="510">
          <diagramm-item :data="diagrammItem"></diagramm-item
        ></v-dialog>
      </template>

      <template v-slot:item="{ item }">
        <tr class="orange lighten-4">
          <td class="deep-orange--text">{{ item.name }}</td>
          <td>{{ item.department }}</td>
          <td>
            <v-chip color="deep-orange" dark>
              {{ item.skill }}
            </v-chip>
          </td>
          <td class="blue-grey lighten-4">soll_daten</td>
          <td
            class="blue-grey lighten-4"
            v-for="(month, index) in item.soll_daten"
          >
            {{ month }}
          </td>
          <td class="blue-grey lighten-3">
            {{
              item.soll_daten.reduce(function (pv, cv) {
                return pv + cv;
              }, 0)
            }}
          </td>
        </tr>
        <tr>
          <td></td>
          <td>
            <v-icon small color="orange" class="mr-2" @click="diagramm(item)">
              mdi-chart-line
            </v-icon>
          </td>
          <td class="green--text">
            <v-row justify="center" align="center" class="mt-2">
              <p class="orange--text">history</p>
              <p class="green--text">/FC</p>
            </v-row>
          </td>
          <td>ist_daten</td>

          <td
            v-bind:class="
              index >= thisMonth ? 'green lighten-4' : 'orange lighten-5'
            "
            v-for="(month, index) in item.forecast_daten"
          >
            {{ month }}
          </td>
          <td>
            {{
              item.forecast_daten.reduce(function (pv, cv) {
                return pv + cv;
              }, 0)
            }}
          </td>
        </tr>
      </template>
      <template slot="body.append">
        <tr class="white--text blue-grey darken-3">
          <td></td>
          <td>Soll Arbeitsstunden pro Tag</td>

          <td></td>
          <td></td>
          <td v-for="month in this.soll_datenSum">{{ month }}</td>
          <td class="blue-grey darken-1">
            {{
              soll_datenSum.reduce(function (pv, cv) {
                return pv + cv;
              }, 0)
            }}
          </td>
        </tr>
        <tr class="white--text blue-grey darken-3">
          <td></td>
          <td>ist Arbeitsstunden pro Tag</td>

          <td></td>

          <td></td>

          <td v-for="month in ist_datenSum">{{ month }}</td>
          <td class="blue-grey darken-1">
            {{
              ist_datenSum.reduce(function (pv, cv) {
                return pv + cv;
              }, 0)
            }}
          </td>
        </tr>
        <tr class="white--text orange darken-4">
          <td></td>
          <td>Soll-Erreichung in %</td>

          <td></td>

          <td></td>

          <td v-for="month in precent_data">{{ Math.round(month) }} %</td>
          <td class="orange lighten-1">
            {{
              Math.round(
                (ist_datenSum.reduce(function (pv, cv) {
                  return pv + cv;
                }, 0) *
                  100) /
                  soll_datenSum.reduce(function (pv, cv) {
                    return pv + cv;
                  }, 0)
              )
            }}
            %
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Anzahl. Arbeitstage S.A</td>

          <td></td>

          <td></td>

          <td v-for="month in workDays">{{ month }}Tage</td>
          <td class="">
            {{
              workDays.reduce(function (pv, cv) {
                return pv + cv;
              }, 0)
            }}
            Tage
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

  <script>
import axios from "axios";
import DiagrammItem from "./DiagrammItem.vue";

export default {
  props: ["userdata"],
  components: { DiagrammItem },
  data() {
    return {
      height: this.$vuetify.breakpoint.height,
      loadingo: true,
      year: new Date().getFullYear(),
      thisMonth: new Date().getMonth(),
      currentYear: new Date().getFullYear(),
      monthes: null,
      dialog: false,
      diagrammItem: undefined,
      skills: [],
      department: [],
      workDays: [],
      search: "",
      ist_datenSum: [],
      soll_datenSum: [],
      precent_data: [],
      nameFilterValue: "",
      skillFilterValue: null,
      departmentFilterValue: null,

      myloadingvariable: true,
      headers1: [],
      headers2: [],
    };
  },
  created() {
    axios
      .get(`/forecast/department`)
      .then((res) => {
        this.department = res.data.departments;
        this.department.push("");
        this.skills = res.data.skills;
      })
      .catch((error) => console.log(error.response.data));
    this.getmonthes();
  },
  computed: {
    progress() {
      if (this.userdata) {
        return false;
      }
      return true;
    },

    headers() {
      this.headers1 = ForecastHelper.headers1(this);
      this.headers2 = ForecastHelper.headers2(this);
      switch (this.currentYear) {
        case 2022:
          return this.headers2;
        default:
          return this.headers1;
      }
    },
    years() {
      let year = new Date().getFullYear();
      let arr = [];
      for (let i = year - 4; i <= year + 1; i++) {
        arr.push(i);
      }
      return arr;
    },
  },
  methods: {
    getmonthes() {
      let arr = [];
      let temp = this.thisMonth + 1;
      for (let i = 1; i <= 12; i++) {
        arr.push(temp);
        temp++;
        if (temp == 13) {
          temp = 1;
        }
      }
      this.monthes = arr;
    },

    listen() {
      EventBus.$on("startEditing", () => {
        this.editing = true;
      });
    },
    diagramm(item) {
      EventBus.$emit("diagrammUpdate", { item: item, headers: this.headers });
      this.diagrammItem = { item: item, headers: this.headers };
      this.dialog = true;
    },
    changeyear(e) {
      this.currentYear = e;
      this.headers;

      this.$emit("inputChange", e);
    },

    datenSum(e) {
      let i;
      var is_datenSum0 = [];
      var soll_datenSum0 = [];

      for (i = 0; i < Object.keys(e).length; i++) {
        is_datenSum0[i] = e[i].forecast_daten;
        soll_datenSum0[i] = e[i].soll_daten;
      }

      if (this.userdata) {
        this.ist_datenSum = is_datenSum0[0].map((x, idx) =>
          is_datenSum0.reduce((sum, curr) => sum + curr[idx], 0)
        );
        this.soll_datenSum = soll_datenSum0[0].map((x, idx) =>
          soll_datenSum0.reduce((sum, curr) => sum + curr[idx], 0)
        );

        for (i = 0; i < 12; i++) {
          this.precent_data[i] =
            (this.ist_datenSum[i] * 100) / this.soll_datenSum[i];
        }
      }
      if (this.userdata) {
        this.workDays = this.userdata[1].workDays;
      }
    },
    sumField(key) {
      // sum data in give key (property)
      return this.userdata.reduce((a, b) => a + (b[key] || 0), 0);
    },
    nameFilter(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.nameFilterValue) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value.toLowerCase().includes(this.nameFilterValue.toLowerCase());
    },
    skillFilter(value) {
      if (!this.skillFilterValue) {
        return true;
      }
      return value.toLowerCase().includes(this.skillFilterValue.toLowerCase());
    },
    departmentFilter(value) {
      if (!this.departmentFilterValue) {
        return true;
      }

      return value
        .toLowerCase()
        .includes(this.departmentFilterValue.toLowerCase());
    },

    loading() {
      if (userdata) {
        this.myloadingvariable = false;
      }
    },
  },
};
</script>
<style scoped>
.v-data-table {
}
</style>